module.exports = __webpack_public_path__ + "img/yell-green-mob.397a5643.png";